import { takeLatest, call, put, select } from "redux-saga/effects";
import axios from "../../utils/axios";
import log from "loglevel"

import getEnvParam from "../../utils/getEnvParam";

const getConciliationSeal = (conciliationId, token) => {
    return new Promise((resolve, reject) => {
        return axios.request(getEnvParam("REACT_APP_BFF_URL_REST") + "/seloConciliacoes/gerar/" + conciliationId,{
            method: "GET",
            headers: {
                "NPF_ROUTE": getEnvParam("REACT_APP_HEADER_SELO"),
                "Content-Type": "application/json",
                "Authorization": token,
            },
        })
            .then(response => response.status !== 200 ? reject(response) : response)
            .then(response => response.data)
            .then(response => resolve(response))
            .catch(error => {
                reject(error);
                log.info(error);
            });
    });
};

//generators
function* conciliationSeal(payload) {
    try {
        const authentication = state => state.authentication;
		
		const { token } = yield select(authentication);

        const result = yield call(getConciliationSeal, payload.conciliationId, token);

        yield put({ type: "CONCILIATION_SEAL", payload: result});
    } catch (error) {
        //Este bloco em producao deverah ser melhor tratado e
        //apresentar uma mensagem para o cliente
        log.info(error);
    }
}

// //Generator function
export function* conciliationSealtWatcher() {
    yield takeLatest("GET_CONCILIATION_SEAL", conciliationSeal);
}
